var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450 524L450 552",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.5,
    cy: 519.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.987 519.19C445.987 515.283 449.288 512.117 453.358 512.117C453.943 512.117 454.511 512.184 455.056 512.308C453.742 511.48 452.187 511 450.519 511C445.814 511 442 514.806 442 519.5C442 524.194 445.814 528 450.519 528C452.814 528 454.895 527.093 456.427 525.62C455.492 526.032 454.454 526.263 453.358 526.263C449.288 526.263 445.987 523.096 445.987 519.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.402 518.6L459.37 516.146L457.535 517.719L455.304 517.056L456.112 519.337L454.765 521.381L457.1 521.218L458.499 523.144L459.133 520.763L461.345 519.909L459.402 518.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.9e9b94086cd372f946db71fd9ccb04c6.svg";
export { ForwardRef as ReactComponent };